import { ChangeDetectionStrategy, Component, signal, Signal, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BreadcrumbService } from '@mglsk/ng-breadcrumb';
import { ActionService } from '@mglsk/ng-actions';
import { BreadcrumbComponent } from '@mglsk/ng-breadcrumb/prime/breadcrumbs';
import { ViewActionsComponent } from '@mglsk/ng-actions/prime/view-actions';
import { MenuItem } from 'primeng/api';
import { MenuModule } from 'primeng/menu';
import { CardModule } from 'primeng/card';
import { environment } from '../../../../environments/environment';
import { AuthService, User } from '@mglsk/ng-auth';
import { toSignal } from '@angular/core/rxjs-interop';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-base-app',
  imports: [RouterOutlet, MenuModule, CardModule, BreadcrumbComponent, ViewActionsComponent, Button],
  providers: [BreadcrumbService, ActionService],
  templateUrl: './base-app.component.html',
  styleUrl: './base-app.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaseAppComponent {
  readonly version = environment.build;
  readonly user: Signal<undefined | null | User>;

  breadcrumbs: Signal<MenuItem[]>;
  sidenavItems = [
    {
      label: 'Jobs',
      icon: 'pi pi-briefcase',
      routerLink: ['/', 'jobs'],
    },
    {
      label: 'Companies',
      icon: 'pi pi-building',
      routerLink: ['/', 'companies'],
    },
  ];

  constructor(
    private readonly breadcrumbService: BreadcrumbService,
    private readonly authService: AuthService,
  ) {
    this.breadcrumbs = this.breadcrumbService.breadcrumbs;
    this.user = toSignal(authService.user);
  }

  logout() {
    this.authService.logout();
  }
}
